import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import APICom from "../../utils/helpers/APICom";
import TimePicker from "rc-time-picker";
import ConfirmationModal from '../Controls/ConfirmationModal';
import PersistStorage from "../../utils/helpers/PersistStorage";
import DateTimeUtils from "../../utils/DateTimeUtility";
import '../../../src/assets/Styles/TripDetailsCSS/TripDetails.css';

function TripDetailsDialog(props){

    const [showWillCallControl, setShowWillCallControl] = useState(false);
    const [isWillCallRequest, setIsWillCallRequest] = useState(() => {
        try {
            const pickupTime = props.GridRowData[0].PickupTime;
            if (pickupTime && (pickupTime === "Will Call" || pickupTime == "MSchWC")) {
                setShowWillCallControl(true);
              return true;
            } else {
                setShowWillCallControl(false);
              return false;
            }
        } catch (error) {
            console.log("Unable to read [PickupTime]")
            return false;
        }
       
    });

    const handleCheckboxChange = (e) => {
        setIsWillCallRequest(e.target.checked);
    };

    const { ASCSSettingData, FundingSourceData, MvRouteSettingData, AttributeData }  = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);


    const [loadingSummary, setLoadingSummary] = useState(true);
    const [loadingDetailed, setLoadingDetailed] = useState(true);
    const [mobilityDataSummaryLst, setMobilityDataSummaryLst] = useState([]);
    const [mobilityDataDetailedLst, setMobilityDataDetailedLst] = useState([]);
    const [isMobilityAttributes, setIsMobilityAttributes] = useState(false);

    const [ScheduleTripMinTimeDiff, setScheduleTripMinTimeDiff] = useState(0);
    const [pickRemarks, setPickRemarks] = useState("");
    const [dropRemarks, setDropRemarks] = useState("");

    const [dtWillCallDayOD, setDtWillCallDayOD] = useState(); // From Schedule
    const [dtWillCallDay, setDtWillCallDay] = useState(); // From OnDemand
    const [selectedTableType, setSelectedTableType] = useState("");
    
    const lastValidAppointmentTime = useRef(moment());
    const [AppointmentTime, setAppointmentTime] = useState(() => {
        let apptTime = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["ApptTime"]? props.GridRowData[0]["ApptTime"] : "";
        let activeTimeT = "";

        if(apptTime !== ""){
            activeTimeT = moment(apptTime, 'HH:mm');
        }
        else{
            activeTimeT = moment('00:00', 'HH:mm');
        }
        lastValidAppointmentTime.current = activeTimeT;
        return activeTimeT;
    });
    

    const [CallbackInfo, setCallBackInfo] = useState((DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? props.GridRowData[0]["Phone"] : props.GridRowData[0]["CallbackInfo"]) : ""));
    const [PickupPerson, setPickupPerson] = useState((DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["PickupPerson"] : ""));
    const [showActivationAlert, setShowActivationAlert] = useState(false);
    const [activateAlert, setActivateAlert] = useState({alertTitle: '', alertMsg:''});
    const [isEditButtonClicked, setIsEditButtonClicked] = useState(true);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Will Call Warning',
        body:'You are updating a will call request, its time will also be updated', btnCanceText: 'Cancel', btnOkText: 'Ok'}
    );
    const [JobNumber, setJobNumber] = useState((DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? props.GridRowData[0]["Job#"] :  props.GridRowData[0]["PaymentExtention2"]) : ""));
    const [ToolboxValues, SetToolboxValues] = useState(()=>{
        const _startDate = new Date();
        const _TodayDate = _startDate.getFullYear() + (_startDate.getMonth() < 9 ? "-0" : "-") + (_startDate.getMonth() + 1) + "-" + _startDate.getDate();
        return _TodayDate;
    });
    
    const [ExtraInfo, setExtraInfo] = useState((DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["ExtraInformation"]? props.GridRowData[0]["ExtraInformation"] : ""));
    const [isRouted, setIsRouted] = useState(() => {
        try{
            let dataCheck = (DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.gridType === 'Dispatch');
            let routeCheck = (dataCheck && props.GridRowData[0]["Route"] && props.GridRowData[0]["Route"] !== '' ? true : false);
            return routeCheck;
        } catch(err){console.log(err); return false;}
    });
    const xCancelSourceForGrid = useRef(null);
    const apptTimeRef = useRef("");
    const serverTimeRef = useRef("");

    const SPACES = "\u00A0\u00A0";
    const TITLE = "Trip Details";
    const EDIT_BUTTON = "Edit";
    const SAVE_BUTTON = "Save";
    const CANCEL_BUTTON = "Cancel";

    let ConfirmationNumber = DoesGridDataExist(props) > 0 && props.GridRowData[0] ? (props.gridType === 'Standing' ? props.GridRowData[0]["Confirmation #"] : props.GridRowData[0]["ConfirmationNo"]) : "";
    let ServiceStatus = DoesGridDataExist(props) > 0 && props.GridRowData[0] ? (props.gridType === 'Standing' ? "" : props.GridRowData[0]["ServiceStatus"]) : "";
    let RequestType = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? "Time Call" : props.GridRowData[0]["RequestType"]) : "";
    let disablePUPastDates = (RequestType == "Time Call" || RequestType == "TimeCall") ? true : false;
    let ServiceId = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? props.GridRowData[0].iScheduleID : props.GridRowData[0]["ServiceID"]) : -1;
    let PickupDateTime = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? props.GridRowData[0]["dtFrom"] : props.GridRowData[0]["PickupDateTime"]) : "";
    let ReceivedDate = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? "" : props.GridRowData[0]["CallRecieve"]) : "";
    let CreatedBy = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["CreatedBy"] : "";
    let ModifiedBy = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? "" : props.GridRowData[0]["LastModifiedBy"]) : "";
    let RequestedVehicleType = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? (!props.GridRowData[0]["RequiredVehicleType"] || props.GridRowData[0]["RequiredVehicleType"] === "" ? "None" : props.GridRowData[0]["RequiredVehicleType"]) : (props.GridRowData[0]["ReqVehType"]==="" || props.GridRowData[0]["ReqVehType"]===null? "None": props.GridRowData[0]["ReqVehType"])):"";
    let RequestedVehicleDriver = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["VREQ"] : "";
    let DriverPhone = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["DriverCellPhone"]? props.GridRowData[0]["DriverCellPhone"] : "";
    let LastCallback = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["DateCallback"]? props.GridRowData[0]["DateCallback"] : "";
    let CallbackMethod = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["CallbackMethod"]? props.GridRowData[0]["CallbackMethod"] : "";
    let CalloutStatus = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["CallOutStatus"]? (props.GridRowData[0]["CallOutStatus"]==="" || props.GridRowData[0]["CallOutStatus"]===null? "None":props.GridRowData[0]["CallOutStatus"]) : "";
    let EstimatedMiles = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["EstimatedDistance"] : "";
    let EstimatedFare = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["EstimatedCost"] : "";
    let EstimatedMins = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["EstimatedTime"] : "";
    let InstructionsCount = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["iInstructionCount"] : "";
    let ProviderMiles = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["ProviderMileage"]? props.GridRowData[0]["ProviderMileage"] : "";
    let ProviderFare = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["ProviderCost"]? props.GridRowData[0]["ProviderCost"] : "";
    let PayType = DoesGridDataExist(props) > 0 && props.GridRowData[0]? props.GridRowData[0]["PaymentMethod"] : "";
    let Account = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? props.GridRowData[0]["Funding Source"] : props.GridRowData[0]["FundingSource"]) : "";
    let PickupZip = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["PickupZip"]? props.GridRowData[0]["PickupZip"] : "";
    let DropOffZip = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["DropZip"]? props.GridRowData[0]["DropZip"] : "";
    let PaymentExtention1 = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["PaymentExtention1"]? props.GridRowData[0]["PaymentExtention1"] : "";
    let PaymentExtention3 = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["PaymentExtention3"]? props.GridRowData[0]["PaymentExtention3"] : "";
    let iFundingSourceID = DoesGridDataExist(props) > 0 && props.GridRowData[0] && props.GridRowData[0]["iFundingSourceID"]? props.GridRowData[0]["iFundingSourceID"] : "";
    let TableSource = DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.gridType === 'Standing' ? "Time Call" : props.GridRowData[0]["TableSource"]) : "";
    let PickupAddressPOI = GetPickupAddressPOI();
    let DropOffAddressPOI = GetDropoffAddressPOI();

    const lastPickuTimeRef = useRef(moment());
    const [pickupTime, setTimeValue] = useState(()=>{
        const timeMatch = (PickupDateTime !== "" ? PickupDateTime.match(/(\d{1,2}:\d{2}\s?[APM]{2})/i) : null);
        let PUTime = (timeMatch ? timeMatch[1] : "");
        let activateTime = "";
        if(PUTime !== "")
        {
            activateTime = moment(PUTime, 'hh:mm A');
        }
        else
        {
            activateTime = moment('00:00 A', 'hh:mm A');
        }
        lastPickuTimeRef.current = activateTime;

        return activateTime;
    });

    const [pickupDate, setDateValue] = useState(()=>{
        const dateMatch = (PickupDateTime !== "" ? (PickupDateTime.match(/^(\d{1,2}\/\d{1,2}\/\d{4})/)) : null); //extracting date only with any amount of space in between
        let PUDate = (dateMatch ? dateMatch[1] : "1/1/1900");
        const timeMatch = (PickupDateTime !== "" ? PickupDateTime.match(/(\d{1,2}:\d{2}\s?[APM]{2})/i) : null);
        let PUTime = (timeMatch ? timeMatch[1] : "00:00:00");
        let foundDate = moment(`${PUDate} ${PUTime}`, "MM/DD/YYYY h:mmA").toDate();
        return foundDate;
    });

    useEffect(()=>{
        try{

            if(props.GridRowData.length === 0)
            {
                setActivateAlert({...activateAlert, alertTitle: 'No Trip Selected', alertMsg:'Please select a trip to continue...'});
                setShowActivationAlert(true);
                return;
            }

            let hasMobilityAttributes = AttributeData
            ? AttributeData.some((item) => {
                return (
                  parseInt(item.iAttrATSPID) === parseInt(props.GridRowData[0].iSRATSPID) &&
                  parseInt(item.iAttrType) === 10
                );
              })
            : false;
            if(hasMobilityAttributes){
                setIsMobilityAttributes(true);
            }
            else{
                setIsMobilityAttributes(false);
            }
        const GetMRMSDetailedData = async(ConfirmationNo) => {
            try{
              let data = {
                "confirmationno": String(ConfirmationNo),
                "dtPickupDate": "",
                "iRoutedFilter": -1,
                "imode": 2,
                "dHoursToShowFutureTrips": -1
              };
              let response = await APICom.fetchData("","GridData/GetMRMSDetailedData", "post", {}, data, xCancelSourceForGrid.current);
              if(response !== undefined && response && response?.data && response?.data !== undefined){
                debugger
                PickupRemarks(response);
                DropOffRemarks(response);
                ExtraInformation(response);
                DtWillCallDayOD(response);
                DtWillCallDay(response);
              }
          
              PopulateMobilityAttributes(response);
          

              serverTimeRef.current = await getServerTime();
            }
            catch(err){console.log(err);}
        };
        GetMRMSDetailedData(ConfirmationNumber);
        
        } catch (err) {console.log(err);}
    }, []);

    const PickupRemarks = (response) => {
        try {
            if(response != undefined && response != null){
                if(response?.data?.vPickRemarks !== undefined && response?.data?.vPickRemarks){
                    setPickRemarks(response.data.vPickRemarks);
                }
                else if(response?.data[0][0]?.vPickRemarks !== undefined && response?.data[0][0]?.vPickRemarks !== null){
                    setPickRemarks(response.data[0][0].vPickRemarks);
                }
            }
        } catch (error) {
            setPickRemarks("");
        }
    }

    const DropOffRemarks = (response) => {
        try {
            if(response != undefined && response != null){
                if(response?.data?.vDropRemarks !== undefined && response?.data?.vDropRemarks){
                    setDropRemarks(response.data.vDropRemarks);
                }
                else if(response?.data[0][0]?.vDropRemarks !== undefined && response?.data[0][0]?.vDropRemarks !== null){
                    setDropRemarks(response.data[0][0].vDropRemarks);
                }
            }
        } catch (error) {
            setDropRemarks("");
        }
    }

    
    const ExtraInformation = (response) => {
        try {
            if(response != undefined && response != null){
                if(response?.data?.ExtraInformation !== undefined && response?.data?.ExtraInformation){
                    setExtraInfo(response.data.ExtraInformation);
                }
                else if(response?.data[0][0]?.ExtraInformation !== undefined && response?.data[0][0]?.ExtraInformation !== null){
                    setExtraInfo(response.data[0][0].ExtraInformation);
                }
            }
        } catch (error) {
            setExtraInfo("");
        }
    }

    const DtWillCallDayOD = (response) => {
        try 
        {
            if(response != undefined && response != null){
                if(response?.data[0][0].SelectedTableType == "OD"){
                    setSelectedTableType(response.data[0][0].SelectedTableType);
                    if(response?.data[0][0].dtWillCallDay){
                        setDtWillCallDayOD(response.data[0][0].dtWillCallDay);
                    }
                }
            }
        } catch (error) {
            
        }
    }

    const DtWillCallDay = (response) => {
        try 
        {
            if(response != undefined && response != null){
                if(response?.data[0][0].SelectedTableType == "SS"){
                    setSelectedTableType(response.data[0][0].SelectedTableType);
                    if(response?.data[0][0].dtWillCallDay){
                        setDtWillCallDay(response.data[0][0].dtWillCallDay);
                    }
                }
            }
        } catch (error) {
            
        }
    }


    const PopulateMobilityAttributes = (response) => {
        try 
        {
            if(response?.data[1] != undefined){
                let sumryLst = response.data[1];
                const mobilitySummyLst = MobilitySummaryList(sumryLst);
                if(mobilitySummyLst){
                    setMobilityDataSummaryLst(mobilitySummyLst);
                    setLoadingSummary(false);
                }
            }

            if(response?.data[2] != undefined){
                let detailedLst = response?.data[2];
                const mobilityDtldLst = MobilityDetailedList(detailedLst);
                if(mobilityDtldLst){
                    setMobilityDataDetailedLst(mobilityDtldLst);
                    setLoadingDetailed(false);
                }
            }
            
        } 
        catch (error) {}
    }

    const generateColorMap = (data) => {
        const colors = [
            '#f4cccc', // light red
            '#d9ead3', // light green
            '#fff2cc', // light yellow
            '#c9daf8', // light blue
            '#fce5cd', // light orange
            '#d9d2e9', // light purple
            '#d0e0e3', // light cyan
            '#ead1dc', // light pink
            '#e6f5a9', // light lime
            '#fde9d9', // light peach
            '#cfe2f3'  // pale teal
        ];
        const colorMap = {};
        let colorIndex = 0;
      
        data?.forEach(item => {
          if (!colorMap[item.PaxType]) {
            colorMap[item.PaxType] = colors[colorIndex % colors.length];
            colorIndex++;
          }
        });
      
        return colorMap;
      };
      

    const MobilitySummaryList = (data) => {
        let totalPassengers = 0
        if(data){
            totalPassengers =  data?.reduce((sum, item) => sum + (item.PaxCount || 0), 0);
        }
        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: "12px", overflowY: "auto", height: "50px" }}>
              <thead style={{background: "azure"}}>
                <tr>
                  <th style={{ textAlign: 'left', padding: '5px', borderBottom: '1px solid #ccc' }}>Mobility</th>
                  <th style={{ textAlign: 'left', padding: '5px', borderBottom: '1px solid #ccc', textAlign: "center"  }}>PaxCount</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ padding: '5px', borderBottom: '1px solid #eee' }} title={item.vTitle}>{item.Mobility}</td>
                    <td style={{ padding: '5px', borderBottom: '1px solid #eee', textAlign: "center" }}>{item.PaxCount}</td>
                  </tr>
                ))}
                <tr>
                    <span style={{ textAlign: 'left', padding: '5px', borderBottom: '1px solid #ccc',  fontWeight:"bold" }}>Total</span>
                    <td style={{ padding: '5px', borderBottom: '1px solid #eee', fontWeight:"bold", textAlign: "center"  }} >{totalPassengers}</td>
                </tr>
              </tbody>
            </table>
          );
    };

    const MobilityDetailedList = (data) => {
        const colorMap = generateColorMap(data);
        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: "12px", overflowY: "auto", height: "50px" }}>
              <thead style={{background: "azure"}}>
                <tr>
                  <th style={{ textAlign: 'left', padding: '5px', borderBottom: '1px solid #ccc'  }}>Mobility</th>
                  <th style={{ textAlign: 'left', padding: '5px', borderBottom: '1px solid #ccc'}}>PaxType</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ padding: '5px', borderBottom: '1px solid #eee'}} title={item.vTitle}>{item.Mobility}</td>
                    <td style={{ padding: '5px', borderBottom: '1px solid #eee' }}>
                    <span style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: colorMap[item.PaxType],
                        display: 'inline-block',
                        marginRight: "10px"
                        }}>
                    </span>
                        
                       {item.PaxType}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          );
    };

    const handleCloseTripDetailsDialog = () => {
        try{
            if (props.showTripDetailsDialog) {
                let IsTripDetailsDialogOpened = PersistStorage.retrieve("IsTripDetailsDialogOpened", false);
                if(typeof IsTripDetailsDialogOpened !== 'undefined' && IsTripDetailsDialogOpened)
                {
                    PersistStorage.save("IsTripDetailsDialogOpened", false, 0, false);
                }
                props.setTripDetailsDialog(false);
            }
        } catch(err){console.log(err);}
    };

    const handleEditButton = () => {
        if(isEditButtonClicked)
        {
            setIsEditButtonClicked(false);
        }
        else
        {
            setIsEditButtonClicked(true);
        }
    };

    const ChangePickRemarks = (pickRmks) => {
        setPickRemarks(pickRmks);
    };

    const ChangeDropRemarks = (dropRmks) => {
        setDropRemarks(dropRmks);
    };
    
    const ChangePickupPerson = (name) => {
        setPickupPerson(name);
    };
    
    const ChangeCallbackInfo = (callbackInfo) => {
        setCallBackInfo(callbackInfo);
    };

    const ChangeAppointmentTime = async (appTime) => {
        try{
            if(appTime)
            {
                 const selectedDate = moment(pickupDate);
                 const timeOnly = moment(appTime, 'hh:mm A');
         
                 const updatedDateTime = selectedDate.set({
                     hour: timeOnly.hour(),
                     minute: timeOnly.minute(),
                     second: 0,
                     millisecond: 0
                 });
         
                 let serverTime = await GetAndFormatServerTime();
     
                 if (updatedDateTime.isBefore(serverTime)) {
                     alert("You cannot select a past time.");
                     setAppointmentTime(lastValidAppointmentTime.current.clone());
                     return;
                 }
                 setAppointmentTime(updatedDateTime);
 
 
                 // let activateAppt = moment(appTime, 'HH:mm');
                 // let militaryTime = moment(appTime, 'HH:mm').format('HH:mm');
                 // apptTimeRef.current = militaryTime;
            }
        } catch(err){console.log(err);}
    };
    
    const ChangeJobNumber = (jobNumber) => {
        setJobNumber(jobNumber);
    };

    const ChangeExtraInfo = (extraInfo) => {
        setExtraInfo(extraInfo);
    };

    const GetTotalCanclNoShow = () => {
        let noShow = (DoesGridDataExist(props) > 0 && props.GridRowData[0]? (props.GridRowData[0]["TotalNoShows"] ? props.GridRowData[0]["TotalNoShows"] : 0) : "");
        let totalCancelled = (DoesGridDataExist(props) > 0 ? (props.GridRowData[0]["TotalCancelled"] ? props.GridRowData[0]["TotalCancelled"] : 0) : "");
        noShow = (noShow == '') ? 0 : noShow;
        let totalCancelNoShow = totalCancelled + " / " + noShow;

        return totalCancelNoShow
    };

    function GetPickupAddressPOI () {
        let PickupAddress = (DoesGridDataExist(props) > 0 && props.GridRowData[0])? (props.gridType === 'Standing' ? props.GridRowData[0]["Pick Location"] : props.GridRowData[0]["PickupAddress"] ) : "";
        let POI = (DoesGridDataExist(props) > 0 && props.GridRowData?.[0]) ? (props.gridType === 'Standing' ? props.GridRowData[0]["Pickup POI"] : props.GridRowData[0]["PickupPOI"]) : "";
        let PickupAddressPOI = PickupAddress + (POI ? " / " + POI : "");

        return PickupAddressPOI
    }

    function GetDropoffAddressPOI () {
        let DropOffAddress = (DoesGridDataExist(props) > 0 && props.GridRowData[0])? (props.gridType === 'Standing' ? props.GridRowData[0]["Dest Location"] : props.GridRowData[0]["Destination"]) : "";
        let DropPOI = (DoesGridDataExist(props) > 0 && props.GridRowData?.[0]) ? (props.gridType === 'Standing' ? props.GridRowData[0]["Dropoff POI"] : props.GridRowData[0]["DropoffPOI"]) : "";

        let DropOffAddressPOI = DropOffAddress + (DropPOI ? " / " + DropPOI : "");

        return DropOffAddressPOI
    }
    
    const handlePickupDateChange = (date) => {
        const newDate = new Date(date);//+" 00:00:00");
        setDateValue(newDate);
    };
    

    const handleRequestPickupTimeChange = async (pickTime) => {
        // if(pickTime)
        // {
        //   let activateAppt = moment(pickTime, ' hh:mm A');
        //   setTimeValue(activateAppt);
        // }
        if (pickTime && pickupTime && pickupDate) {
            const selectedDate = moment(pickupDate);
            const timeOnly = moment(pickTime, 'hh:mm A');
    
            const updatedDateTime = selectedDate.set({
                hour: timeOnly.hour(),
                minute: timeOnly.minute(),
                second: 0,
                millisecond: 0
            });
    
            let serverTime = await GetAndFormatServerTime();

            if (updatedDateTime.isBefore(serverTime)) {
                alert("You cannot select a past time.");
                setTimeValue(lastPickuTimeRef.current.clone());
                return;
            }
            setTimeValue(updatedDateTime);
        }
        
    };

    async function GetAndFormatServerTime()
    {
        let formattedServerDBDateTime;
        try {
            let ServerDBDateTime = await getServerTime();

            if(ServerDBDateTime != undefined)
            {
                let _serverDate = ServerDBDateTime.split(' ')[0];
                let _serverTime = ServerDBDateTime.split(' ')[1];

                _serverDate = new Date(_serverDate+" 00:00:00");
                _serverTime = moment(_serverTime, 'hh:mm A');

                const tempServerDate = moment(_serverDate, 'YYYY-MM-DD');
                const tempServerTime = moment(_serverTime, 'HH:mm');

                formattedServerDBDateTime = tempServerDate.set({
                    hour: tempServerTime.hours(),
                    minute: tempServerTime.minutes(),
                    second: tempServerTime.seconds(),
                });
            }
        } catch (error) {
            return undefined;
        }
        return formattedServerDBDateTime;
    }

    function DoesGridDataExist(props)
    {
        try {
            let lengthOfGridData =  props?.GridRowData?.length;
            if(lengthOfGridData > 0)
                return lengthOfGridData;
            else
                return 0;
        } catch (error) {return 0;}
    }

    const handleAlertModalClose = () => {
        setShowActivationAlert(false);
    };

    const handleValidateTripInformation = async() => {
        let tripInformationObject = 
        { "iServiceID": "-1", "vPickupPerson" : "", "dtPickupDate": "", "iPaymentTypeID" : '', 
        "vExt1" : '',"vExt2" : '', "vExt3" : '', "vCallBackInfo" : '', "vCustomerEmail" : '',
        "vExtraInfo" : '', "fundingSourceID" : '', "dtAppTime" : '', "RefID": "-1", "iUserID": "-1",
        "vPickupRemarks": '', "vDropRemarks": ""
        };

        getScheduleTripMinTimeDiff();
        const dateMoment = moment(pickupDate, 'YYYY-MM-DD');
        const timeMoment = moment(pickupTime, 'HH:mm A');

        const combinedMoment = dateMoment.set({
            hour: timeMoment.hours(),
            minute: timeMoment.minutes(),
            second: timeMoment.seconds(),
        });
        let datetime = combinedMoment.format('YYYY-MM-DD HH:mm');
        let Apptdatetime = "1900-01-01 12:00 AM";
        if(AppointmentTime.hours() > 0 || AppointmentTime.minutes() > 0 || AppointmentTime.seconds() > 0){
            let combinedMomentApptTime = dateMoment.set({
                hour: AppointmentTime.hours(),
                minute: AppointmentTime.minutes(),
                second: AppointmentTime.seconds(),
            });
            Apptdatetime = combinedMomentApptTime.format('YYYY-MM-DD HH:mm');
        }
        
        tripInformationObject["ServiceID"] = ServiceId;
        tripInformationObject["vPickupPerson"] = PickupPerson;
        if(isRouted == false){
            if(isWillCallRequest == true){
                tripInformationObject["dtPickupDate"] = "1900-01-01 00:00";
    
                tripInformationObject["dtWillCallDay"] = (datetime !== "" ? datetime : "");
                tripInformationObject["bWillCall"] = 1;
    
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"].replace('AM','');
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"].replace('PM','');
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"];
                
    
            }
            else{
                tripInformationObject["dtPickupDate"] = (datetime !== "" ? datetime : "");
                tripInformationObject["dtWillCallDay"] = '1900-01-01 00:00';
                tripInformationObject["bWillCall"] = 0;
            }
    
        }
        else{
            tripInformationObject["dtPickupDate"] = (datetime !== "" ? datetime : "");
            tripInformationObject["dtWillCallDay"] = '1900-01-01 00:00';
            tripInformationObject["bWillCall"] = 0;
        }
        
        tripInformationObject["iPaymentTypeID"] = -1;
        tripInformationObject["vExt1"] = PaymentExtention1;
        tripInformationObject["vExt2"] = JobNumber;
        tripInformationObject["vExt3"] = PaymentExtention3;
        tripInformationObject["vCallBackInfo"] = CallbackInfo;
        tripInformationObject["vCustomerEmail"] = "";
        tripInformationObject["fundingSourceID"] = String(iFundingSourceID);
        tripInformationObject["dtAppTime"] = Apptdatetime;
        tripInformationObject["RefID"] = ConfirmationNumber;
        tripInformationObject["iUserID"] = loginData.iUserID;
        tripInformationObject["vExtraInfo"] = ExtraInfo;
        tripInformationObject["vPickupRemarks"] = pickRemarks;
        tripInformationObject["vDropRemarks"] = dropRemarks;

        let result = await validationForTripInformationSaving(tripInformationObject);
        if(result == true){
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('AM','');
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('PM','');
            tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"];
            handleConfirmationModalOkFunction();
            //handleSaveTripInformation(tripInformationObject);
        }
        let IsTripDetailsDialogOpened = PersistStorage.retrieve("IsTripDetailsDialogOpened", false);
        if(IsTripDetailsDialogOpened != undefined && IsTripDetailsDialogOpened != null)
        {
            PersistStorage.save("IsTripDetailsDialogOpened", false, 0, false);
        }
    };


    const handleSaveTripInformation = async(tripInformationObject) => {
        try {
            let response = await APICom.fetchData("", "DispatchActions/UpdatePartialTripInformation", "post", { "Content-Type": "application/json" }, tripInformationObject, null);
            let result = response.data;
            if(Number(result.length) > 0)
            {
                setActivateAlert({...activateAlert, alertTitle: 'Updated', alertMsg:'Successfully updated.'});
                setShowActivationAlert(true);
                handleCloseTripDetailsDialog(); 
                return false;
            }
            else
            {
                setActivateAlert({...activateAlert, alertTitle: 'Upate Failed', alertMsg:'Unable to update.'});
                setShowActivationAlert(true);
                return false;
            }
        } catch (error) {
            
        }
    }

    const validationForTripInformationSaving = async (tripInformationObject) => {
        let _isScheduled = false;
        try {
            if(tripInformationObject !== undefined)
            {
                if(tripInformationObject["fundingSourceID"] == undefined || tripInformationObject["fundingSourceID"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Funding Source cannot be empty.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(tripInformationObject["iPaymentTypeID"] == undefined || tripInformationObject["iPaymentTypeID"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Payment type cannot be empty.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(tripInformationObject["dtPickupDate"] == undefined || tripInformationObject["dtPickupDate"] == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Please enter a valid PU Date.'});
                    setShowActivationAlert(true);
                    return false;
                }
                if(pickupTime == undefined || pickupTime == ""){
                    setActivateAlert({...activateAlert, alertTitle: 'Missing Fields', alertMsg:'Please enter a valid PU Time.'});
                    setShowActivationAlert(true);
                    return false;
                }
                _isScheduled = setIsScheduled(tripInformationObject["dtPickupDate"], PickupDateTime);

                if(_isScheduled)
                {
                    let ServerDBDateTime = await getServerTime();
                    let formattedServerDBDateTime;

                    let _ScheduleTripMinTimeDiff = 0;
                    if(ScheduleTripMinTimeDiff != undefined && ScheduleTripMinTimeDiff != -1){
                        _ScheduleTripMinTimeDiff = ScheduleTripMinTimeDiff / 60;
                    }


                    if(ServerDBDateTime != undefined)
                    {
                        let _serverDate = ServerDBDateTime.split(' ')[0];
                        let _serverTime = ServerDBDateTime.split(' ')[1];

                        _serverDate = new Date(_serverDate+" 00:00:00");
                        _serverTime = moment(_serverTime, 'hh:mm A');

                        const tempServerDate = moment(_serverDate, 'YYYY-MM-DD');
                        const tempServerTime = moment(_serverTime, 'HH:mm');

                        formattedServerDBDateTime = tempServerDate.set({
                            hour: tempServerTime.hours(),
                            minute: tempServerTime.minutes(),
                            second: tempServerTime.seconds(),
                        });

                        formattedServerDBDateTime = formattedServerDBDateTime.clone().add(_ScheduleTripMinTimeDiff, 'minutes');
                        formattedServerDBDateTime = formattedServerDBDateTime.format('YYYY-MM-DD HH:mm A');
                    }

                    const minDate = new Date(1,0,1);
                    if(tripInformationObject["dtPickupDate"] == minDate.toISOString() && isWillCallRequest == false)
                    {
                        setActivateAlert({...activateAlert, alertTitle: 'Schedule Date & Time', alertMsg:'Please enter a valid time value for schedule time.'});
                        setShowActivationAlert(true);
                        return false;
                    }
                    
                    //const differenceInMinutes = formattedServerDBDateTime.diff(moment(tripInformationObject["dtPickupDate"], 'YYYY-MM-DD HH:mm'), 'minutes');
                   
                    let selectedDateTime = moment(tripInformationObject["dtPickupDate"], 'YYYY-MM-DD HH:mm A');
                    let serverDT = moment(formattedServerDBDateTime,  'YYYY-MM-DD HH:mm A');

                    if (serverDT.isAfter(selectedDateTime) && RequestType.toUpperCase() != "WILLCALL" &&  isWillCallRequest == false) {
                        setActivateAlert({...activateAlert, alertTitle: 'Schedule Date & Time', alertMsg:"The current time is [" + 
                            ServerDBDateTime.toString() + "]," + " please choose [" + _ScheduleTripMinTimeDiff.toString() + 
                            "] mins ahead of current time to book a scheduled ride."});
                        setShowActivationAlert(true);
                        return false;
                    }

                    if(RequestType.toUpperCase() == "WILLCALL"){
                        if(isWillCallRequest == false)
                        {
                            setConfirmationModalObj((prevState) => ({...prevState, ...{show: true, title:"Will Call Warning", 
                            body:"You are updating a will call request, its time will also be updated", 
                            btnCancelText: 'Cancel', btnOkText: 'Ok'}}));
                        }
                        else {

                        }
                        return true;
                    }
                    return true;
                }
                else
                {
                    return true;
                }
            }
        } catch (error) {
            return false;
        }
    }

    function setIsScheduled(newPUDateTime, oldPUDateTime)
    {
        let _isScheduled = false;
        try {
            if(TableSource == "FromOnDemandTable"){
                const newPU = moment(newPUDateTime, 'MM/DD/YYYY hh:mmA');
                const oldPU = moment(oldPUDateTime, 'MM/DD/YYYY hh:mmA');
                if (newPU.isAfter(oldPU)) {
                    _isScheduled = true;
                }
                
                // if (newPUDateTime != moment(oldPUDateTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY') ||
                //     newPUDateTime != moment(oldPUDateTime, 'MM/DD/YYYY hh:mmA').format('hh:mmA')) {
                //      _isScheduled = true;
                //  }
             }
             else{
                 _isScheduled = true;
             }
        } catch (error) {
            return false;
        }
        return _isScheduled;
    }

    const handleComputeNewPickupTime = (apptTime, currTime) => {
        try{
            let selectedAff = parseInt(props.GridRowData[0]?.iSRATSPID);
            let selectedFS = parseInt(iFundingSourceID);
            let passengerCount = parseInt(props.GridRowData[0].nTotalPassengers);
            let clientInfo = [];
            let correctFormatDate = pickupDate.toISOString().split('T')[0];
            let targetDate = (correctFormatDate+"T00:00:00");
            let fsSelection = (FundingSourceData && FundingSourceData[parseInt(selectedAff)] && FundingSourceData[parseInt(selectedAff)] !== undefined ? 
                JSON.parse(FundingSourceData[parseInt(selectedAff)]) : []);
            const ERSASettingsData = (MvRouteSettingData && MvRouteSettingData[parseInt(selectedAff)] && MvRouteSettingData[parseInt(selectedAff)] !== "" ? 
                JSON.parse(MvRouteSettingData[parseInt(selectedAff)]) : []);
            const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let fsSelectedData = fsSelection.find((item)=>parseInt(item.FID) === parseInt(selectedFS));
            let selectedDay = new Date(targetDate);
            selectedDay = days[selectedDay.getDay()];
            let bIsUpdate = true;
        
            let FsApptTimeWindow = (fsSelectedData.dApptTimeWindow && fsSelectedData.dApptTimeWindow !== ""? fsSelectedData.dApptTimeWindow : 0);
            let FsServiceTimeAmb = (fsSelectedData.serviceTimeAmb && fsSelectedData.serviceTimeAmb !== "" ? fsSelectedData.serviceTimeAmb : 0);
            let FsSeviceTimeWC = (fsSelectedData.serviceTimeWC && fsSelectedData.serviceTimeWC !== "" ? fsSelectedData.serviceTimeWC : 0);
            let FstimeWindow = (fsSelectedData.timeWindow && fsSelectedData.timeWindow !== "" ? fsSelectedData.timeWindow : 0);
            let FsdEndTimeWindow = (fsSelectedData.dEndTimeWindow && fsSelectedData.dEndTimeWindow !== "" ? fsSelectedData.dEndTimeWindow : 0);
            let FsminRideTime = (fsSelectedData.minRideTime && fsSelectedData.minRideTime !== "" ? fsSelectedData.minRideTime : 0);
            let FsmaxRideTime = (fsSelectedData.maxRideTime && fsSelectedData.maxRideTime !== "" ? fsSelectedData.maxRideTime : 0);
            let FsadditionalSameLocAmb = (fsSelectedData.additionalSameLocAmb && fsSelectedData.additionalSameLocAmb !== "" ? fsSelectedData.additionalSameLocAmb : 0);
            let FsadditionalSameLocWC = (fsSelectedData.additionalSameLocWC && fsSelectedData.additionalSameLocWC !== "" ? fsSelectedData.additionalSameLocWC : 0); 
        
            let bDisableRideSharing = true;
            let MinutesToMinus = 0;
            let ApptWindow = 0;
        
            if(ERSASettingsData.length > 0 && clientInfo && typeof clientInfo === "object")
            {
                let bFound = false;
                let index = 0;
                let selectedERSASetting = null;
                for(let k = 0; k < ERSASettingsData.length; k++)
                {
                    if(ERSASettingsData[k].vScheduleDays && ERSASettingsData[k].vScheduleDays.trim() !== '')
                    {
                        let tempSettingDays = ERSASettingsData[k].vScheduleDays.trim().split('');
                        bFound = (tempSettingDays.find((item)=>(item.toLowerCase()) === selectedDay.charAt(0).toLowerCase()) ? true : false);
                        if(bFound)
                        {
                        index = k;
                        break;
                        }
                    }
                }
                
                if(bFound)
                {
                    bDisableRideSharing = ERSASettingsData[index].bDisableRideSharing;
                    selectedERSASetting = ERSASettingsData[index];
                }
                else //No Setting found for current selected day
                {
                    let defaultERSASettingData = ERSASettingsData.filter(item=>item.bDefault === true);
                    if(defaultERSASettingData && defaultERSASettingData.length > 0)
                    {
                        bDisableRideSharing = ERSASettingsData[0].bDisableRideSharing;
                        selectedERSASetting = ERSASettingsData[0];
                    }
                }
                //PU Time = Appointment Time - Estimated Direct Ride Time from Map Source – Service Time (Amb , Wheel Chair) – Appointment Time window
                if(bDisableRideSharing)
                {
                    MinutesToMinus = 0;
                }
                else
                {
                    let min = 0;
                    let max = 0;
            
                    if(parseInt(FsminRideTime) > 0)
                    {
                        min = parseFloat(FsminRideTime);
                    }
                    else
                    {
                        min = (parseFloat(selectedERSASetting.MinimumRidTimeMin) <= 0 ? 0 : parseFloat(selectedERSASetting.MinimumRidTimeMin));
                    }
            
                    if(parseInt(FsmaxRideTime) > 0)
                    {
                        max = parseFloat(FsmaxRideTime);
                    }
                    else
                    {
                        max = (parseFloat(selectedERSASetting.MaxRideTimePer) <= 0 ? 0 : parseFloat(selectedERSASetting.MaxRideTimePer));
                    }
                    let EstTime = 0;
                    let mrt = (EstTime * parseFloat(max) / 100);
                    mrt = (mrt > parseFloat(min) ? mrt : parseFloat(min));
                    MinutesToMinus = mrt;
                }
                
                //Wheelchair
                let serviceTime = 0;
                if(passengerCount.totalWC > 0)
                {
                    serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeWC && clientInfo.serviceTimeWC !== "" ? clientInfo.serviceTimeWC : 0));
                    if(serviceTime > 0)
                    {
                        MinutesToMinus = MinutesToMinus + (serviceTime * 2);
                    }
                    else if(parseFloat(FsSeviceTimeWC) > 0)
                    {
                        MinutesToMinus = MinutesToMinus + (parseFloat(FsSeviceTimeWC) * 2);
                    }
                    else
                    {
                        MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.WCServiceTime) * 2);
                    }
                }
                else //Amb
                {
                    serviceTime = (Array.isArray(clientInfo) ? 0 : (clientInfo.serviceTimeAmb && clientInfo.serviceTimeAmb !== "" ? clientInfo.serviceTimeAmb : 0));
                    if(serviceTime > 0)
                    {
                        MinutesToMinus = MinutesToMinus + (serviceTime * 2);
                    }
                    else if(parseFloat(FsServiceTimeAmb) > 0)
                    {
                        MinutesToMinus = MinutesToMinus + (parseFloat(FsServiceTimeAmb) * 2);
                    }
                    else
                    {
                        MinutesToMinus = MinutesToMinus + (parseFloat(selectedERSASetting.AmbServiceTime) * 2);
                    }
                }
        
                //Adding appointment time
                if(bIsUpdate && parseFloat(FsApptTimeWindow) > 0)
                {
                    MinutesToMinus = MinutesToMinus + parseFloat(FsApptTimeWindow);
                    ApptWindow = parseFloat(FsApptTimeWindow);
                }
                else
                {
                    MinutesToMinus = MinutesToMinus + parseFloat(selectedERSASetting.dApptTimeWindow);
                    ApptWindow = parseFloat(selectedERSASetting.dApptTimeWindow);
                }
                let tempTime = "";
                let selectedApptTime = apptTime;
                if(selectedApptTime !== "")
                {
                    tempTime = addsubtractMinutesFromMilitaryTime(selectedApptTime, MinutesToMinus);
                    let momentPUTimeVal = moment(tempTime, 'HH:mm');
                    setTimeValue(momentPUTimeVal);
                }
            
          }
        }
        catch(err){console.log(err);}
    };

    function addsubtractMinutesFromMilitaryTime(time24, minutesToSubtract, minutesToAdd = 0) {
        try{
          // Split hours and minutes from the input time
          const [hours, minutes] = time24.split(':').map(Number);
          let totalMinutes = 0;
          if(minutesToAdd !== 0)
          {
            // Calculate total minutes and add
            totalMinutes = hours * 60 + minutes + minutesToAdd;
          }
          else
          {
            // Calculate total minutes and subtract
            totalMinutes = hours * 60 + minutes - minutesToSubtract;
          }
          
    
          // Handle cases where total minutes are negative
          if (totalMinutes < 0) {
            totalMinutes = (24 * 60 + totalMinutes) % (24 * 60); // Wraps around to previous day
          }
    
          // Convert back to hours and minutes
          const newHours = Math.floor(totalMinutes / 60) % 24;
          const newMinutes = totalMinutes % 60;
    
          // Pad hours and minutes with leading zeros if needed
          const paddedHours = String(newHours).padStart(2, '0');
          const paddedMinutes = String(newMinutes).padStart(2, '0');
    
          return `${paddedHours}:${paddedMinutes}`;
        }
        catch(err){
          console.log(err); 
          return time24;
        }
        
    }

    const handleApptTimeCheck = async (e) => {
        try{
            const regex = /(\d{2}:\d{2})(AM|PM)$/;
            // Match the time and AM/PM
            const match = serverTimeRef.current.match(regex);
            let currentTime = (match ? (DateTimeUtils.toMilitaryTime(match[1]+" "+match[2], 0)).military : apptTimeRef.current);
            let timeInput = apptTimeRef.current;
            let time1 = currentTime;
            let time2 = timeInput;

            if(time2 !== "")
            {
                if(parseInt(time1.split(":")[0]) < parseInt(time2.split(":")[0]))
                {
                    handleComputeNewPickupTime(time2, currentTime);
                }
                else if(parseInt(time1.split(":")[0]) === parseInt(time2.split(":")[0]))
                {
                    if(parseInt(time1.split(":")[1]) === parseInt(time2.split(":")[1]))
                    {
                        handleComputeNewPickupTime(time2, currentTime);
                    }
                    else if(parseInt(time1.split(":")[1]) > parseInt(time2.split(":")[1]))
                    {
                        setActivateAlert({...activateAlert, alertTitle: 'Invalid Appointment Time', alertMsg:"Please provide a valid appointment time ahead of the time: "+time1+"."});
                        setShowActivationAlert(true);
                    }
                    else
                    {
                        handleComputeNewPickupTime(time2, currentTime);
                    }
                }
                else
                {
                    if(parseInt(time1.split(":")[0]) > parseInt(time2.split(":")[0]))
                    {
                        handleComputeNewPickupTime(time2, currentTime);
                    }
                }
            } 
            else
            {
                handleComputeNewPickupTime(time2, currentTime);
            }
        }
        catch(err){console.log(err);}
    };

    async function getServerTime()
    {
        try {
            let response = await APICom.fetchData("", "TripActions/GetCurrentDBDateTime", "post", { "Content-Type": "application/json" }, {}, null);
            let result = response.data;
            return result;

        } catch (error) {
            return null;
        }
    }

    function getScheduleTripMinTimeDiff()
    {
        if(ASCSSettingData !== null && ASCSSettingData !== undefined)
        {
            let _iSRATSPID = DoesGridDataExist(props) > 0 ? props.GridRowData[0].iSRATSPID : -1;
            if (ASCSSettingData.hasOwnProperty(props?.GridRowData[0]?.iSRATSPID)) {
                const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[_iSRATSPID]); // Parse JSON string into an array
                for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                {
                    if(ascsSettingDataByAffiliate[i]["SubTitle"] === "ScheduleTripMinTimeDiff")
                    {
                        setScheduleTripMinTimeDiff(ascsSettingDataByAffiliate[i]["value"]);
                    }
                }
            }
        }
    }

    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        handleConfirmationModalOkFunction();
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
    }

    const handleConfirmationModalOkFunction = () => {
        let tripInformationObject = 
        { "iServiceID": "-1", "vPickupPerson" : "", "dtPickupDate": "", "iPaymentTypeID" : '', 
        "vExt1" : '',"vExt2" : '', "vExt3" : '', "vCallBackInfo" : '', "vCustomerEmail" : '',
        "vExtraInfo" : '', "fundingSourceID" : '', "dtAppTime" : '', "RefID": "-1", "iUserID": "-1" 
        };

        getScheduleTripMinTimeDiff();
        const dateMoment = moment(pickupDate, 'YYYY-MM-DD');
        const timeMoment = moment(pickupTime, 'HH:mm A');

        const combinedMoment = dateMoment.set({
            hour: timeMoment.hours(),
            minute: timeMoment.minutes(),
            second: timeMoment.seconds(),
        });
        let datetime = combinedMoment.format('YYYY-MM-DD HH:mm');
        let Apptdatetime = "1900-01-01 12:00 AM";
        if(AppointmentTime.hours() > 0 || AppointmentTime.minutes() > 0 || AppointmentTime.seconds() > 0){
            let combinedMomentApptTime = dateMoment.set({
                hour: AppointmentTime.hours(),
                minute: AppointmentTime.minutes(),
                second: AppointmentTime.seconds(),
            });
            Apptdatetime = combinedMomentApptTime.format('YYYY-MM-DD HH:mm');
        }
        
        tripInformationObject["ServiceID"] = ServiceId;
        tripInformationObject["vPickupPerson"] = PickupPerson;
        if(isRouted == false){
            if(isWillCallRequest == true){
                tripInformationObject["dtPickupDate"] = "1900-01-01 00:00";

                tripInformationObject["dtWillCallDay"] = (datetime !== "" ? datetime : "");
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"].replace('AM','');
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"].replace('PM','');
                tripInformationObject["dtWillCallDay"] = tripInformationObject["dtWillCallDay"];
                
                tripInformationObject["bWillCall"] = 1;
            }
            else{
                tripInformationObject["dtPickupDate"] = (datetime !== "" ? datetime : "");
                tripInformationObject["dtWillCallDay"] = '1900-01-01 00:00';
                tripInformationObject["bWillCall"] = 0;
            }
        }
        else{
            tripInformationObject["dtPickupDate"] = (datetime !== "" ? datetime : "");
            tripInformationObject["dtWillCallDay"] = '1900-01-01 00:00';
            tripInformationObject["bWillCall"] = 0;
        }
        tripInformationObject["iPaymentTypeID"] = -1;
        tripInformationObject["vExt1"] = PaymentExtention1;
        tripInformationObject["vExt2"] = JobNumber;
        tripInformationObject["vExt3"] = PaymentExtention3;
        tripInformationObject["vCallBackInfo"] = CallbackInfo;
        tripInformationObject["vCustomerEmail"] = "";
        tripInformationObject["fundingSourceID"] = String(iFundingSourceID);
        tripInformationObject["dtAppTime"] = Apptdatetime;
        tripInformationObject["RefID"] = ConfirmationNumber;
        tripInformationObject["iUserID"] = loginData.iUserID;
        tripInformationObject["vExtraInfo"] = ExtraInfo;
        tripInformationObject["vPickupRemarks"] = pickRemarks;
        tripInformationObject["vDropRemarks"] = dropRemarks;
        tripInformationObject["iModifiedAppID"] = 26;

        
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('AM','');
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"].replace('PM','');
        tripInformationObject["dtPickupDate"] = tripInformationObject["dtPickupDate"];
        handleSaveTripInformation(tripInformationObject);
    };


    return (
        
        <>
            {props.showTripDetailsDialog && props.GridRowData.length > 0 ? 
                <Modal show={props.showTripDetailsDialog ? 1 : 0} centered onHide={handleCloseTripDetailsDialog} backdrop="static" keyboard={true}  size="lg" animation={true}
                    aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-tripDetails-width">
                    <Modal.Header className='activate_dialog_header_bgcolor tripDetails-DialogHeader user-select-none' closeButton>
                        <Modal.Title>{ TITLE }</Modal.Title>
                    </Modal.Header>
                    <Row className="first-row-tripDetails user-select-none">
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    check_circle
                                </span>
                                <b>Confirmation#:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{ConfirmationNumber}</label>
                        </Col>
                        <Col xs={2} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    preliminary
                                </span>
                                <b>Status:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{ServiceStatus}</label>
                        </Col>
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    history_toggle_off
                                </span>
                                <b>ETA (Live Traffic):{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{"..."}</label>
                        </Col>
                        <Col xs={3} className="py-1">
                            <label className="tripDetails-label text-nowrap float-start">
                                <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                    fact_check
                                </span>
                                <b>Req. Type:{SPACES}</b></label>
                            <label className="tripDetails-label text-nowrap">{RequestType}</label>
                        </Col>
                        <Col xs={1}>
                            <Button className="tripDetails_edit_btn_color" size="sm" onClick={(e)=>{setIsEditButtonClicked(!isEditButtonClicked);}}>
                                {EDIT_BUTTON}
                            </Button>
                        </Col>
                    </Row>
                    <hr className="hr-tripDetails w-100"></hr>
                    <Modal.Body>
                            <Container>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        person_pin_circle
                                                    </span>
                                                    Pickup Person:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <input className="tripDetails-label-dataFields w-100" 
                                                    placeholder="Enter Pickup Person Name" disabled={isEditButtonClicked}
                                                    readOnly={isRouted} style={(isRouted? {cursor:"not-allowed"} : {})}
                                                    value={PickupPerson}
                                                    onChange={ (e) => { ChangePickupPerson(e.target.value) }}
                                                />
                                                
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        date_range
                                                    </span>
                                                    PU DateTime:
                                                </label>
                                            </Col>
                                            <Col xs={4} className="mt-1">
                                                <DatePicker className="tripDetails-label-dataFields w-100" selected={pickupDate} readOnly={isRouted} 
                                                minDate={disablePUPastDates || RequestType == "Will Call" || RequestType == "WillCall" ? new Date() : null}
                                                onChange={ (date) => { handlePickupDateChange(date); }} disabled={(isEditButtonClicked || props.gridType === 'Standing') } />
                                            </Col>
                                            <Col  xs={3} className="mt-1">
                                                <TimePicker className={`tripDetails-label-dataFields w-100 `} disabled={(isEditButtonClicked || props.gridType === 'Standing' || isRouted || isWillCallRequest)}
                                                    onChange={ (date) => { setTimeValue(date); }}
                                                    onClose={ () => {
                                                        if(pickupTime){
                                                            handleRequestPickupTimeChange(pickupTime);
                                                        }
                                                    }}
                                                    value={pickupTime}
                                                    showSecond={false} allowEmpty format={"hh:mm A"} use12Hours />
                                                    {/* {showWillCallControl &&  */}
                                                        <Col>
                                                            <label style={{ display: "inline-flex",justifyContent: "center"}}>
                                                                    <input
                                                                    disabled={isEditButtonClicked || isRouted }
                                                                    type="checkbox"
                                                                    checked={isWillCallRequest}
                                                                    onChange={handleCheckboxChange}
                                                                    />
                                                                   <span style={{fontSize: "small",padding: "5px"}}>Will Call</span> 
                                                            </label>
                                                        </Col>
                                                    {/* } */}
                                            </Col>
                                          
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        schedule
                                                    </span>
                                                    Appt Time:
                                                </label>
                                            </Col>
                                            <Col xs={7} className="mt-1">
                                                <TimePicker className={`tripDetails-label-dataFields w-100`} disabled={(isEditButtonClicked || props.gridType === 'Standing' || isRouted || isWillCallRequest)} 
                                                        onChange={ (date) => { setAppointmentTime(date); }} value={AppointmentTime} 
                                                        onClose={(e) => {
                                                            if(AppointmentTime){
                                                                ChangeAppointmentTime(AppointmentTime);
                                                                handleApptTimeCheck(e);
                                                            }
                                                        }}
                                                        
                                                        readOnly={isRouted}
                                                        showSecond={false} allowEmpty format={"hh:mm A"} use12Hours />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label mt-1"> 
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        tag
                                                    </span>
                                                    Job#:
                                                </label>
                                            </Col>
                                            <Col xs={7} className="mt-1">
                                                <input className="w-100 tripDetails-label-dataFields" placeholder="Enter Job Number" disabled={isEditButtonClicked}
                                                    value={JobNumber} onChange={ (e) => {ChangeJobNumber(e.target.value)}} readOnly={isRouted} style={(isRouted? {cursor:"not-allowed"} : {})}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                            
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        event
                                                    </span>
                                                    Received Date:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ReceivedDate}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        cards
                                                    </span>
                                                    Created By:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CreatedBy}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        person
                                                    </span>
                                                    Modified By:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {ModifiedBy}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                    
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        garage
                                                    </span>
                                                    Req. Veh Type:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {RequestedVehicleType}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        garage
                                                    </span>
                                                    Req. Veh/Drv:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {RequestedVehicleDriver}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        call
                                                    </span>
                                                    Drv Phone:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DriverPhone}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        event
                                                    </span>
                                                    Last CB:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {LastCallback}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        multiple_stop
                                                    </span>
                                                    CB Method:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CallbackMethod}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        info
                                                    </span>
                                                    CB Info:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <input className="tripDetails-label-dataFields w-100" placeholder="Enter Callback Info" disabled={isEditButtonClicked}
                                                    value={CallbackInfo} onChange={ (e) => {ChangeCallbackInfo(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">   
                                                        exclamation
                                                    </span>
                                                    Callout Status:</label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {CalloutStatus}
                                                </label>
                                            </Col>
                                        </Row>
                                    
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row >
                                    <Col className="border rounded py-1 flex" xs={3} lg={isMobilityAttributes ? 6 : 12} >
                                        <Row>
                                        <Col xs={6} className="user-select-none">
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            emoji_flags
                                                        </span>
                                                        Est. Miles:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {EstimatedMiles}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            attach_money
                                                        </span>
                                                        Est. Fare:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {EstimatedFare}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            hourglass_bottom
                                                        </span>
                                                        Est. Mins:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {EstimatedMins}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            functions
                                                        </span>
                                                        Instr Count:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {InstructionsCount}
                                                    </label>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xs={6} className="user-select-none">
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            emoji_flags
                                                        </span>
                                                        Prov. Miles:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {ProviderMiles}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            monetization_on
                                                        </span>
                                                        Prov. Fare:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {ProviderFare}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            credit_card
                                                        </span>
                                                        Pay Type:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {PayType}
                                                    </label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={5}> 
                                                    <label className="tripDetails-label">
                                                        <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                            hdr_auto
                                                        </span>
                                                        Account:
                                                    </label>
                                                </Col>
                                                <Col xs={7}> 
                                                    <label className="tripDetails-label-dataFields w-100">
                                                        {Account}
                                                    </label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        </Row>
                                    </Col>
                                    {isMobilityAttributes &&
                                        <Col xs={6} className="user-select-none border rounded">
                                            <Row>
                                                <Col>
                                                    {loadingSummary ? (
                                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                        <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Loading summary...</span>
                                                        </Spinner>
                                                    </div>
                                                    ) : (
                                                        <div style={{ height: '180px', overflowY: 'auto'}}>
                                                            {mobilityDataSummaryLst}
                                                        </div>
                                                    )}
                                                </Col>

                                                <Col>
                                                    {loadingDetailed ? (
                                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                        <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Loading details...</span>
                                                        </Spinner>
                                                    </div>
                                                    ) : (
                                                        <div style={{ height: '180px', overflowY: 'auto'}}>
                                                        {mobilityDataDetailedLst}
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        where_to_vote
                                                    </span>
                                                    PU Address/POI:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {PickupAddressPOI}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        pin_drop
                                                    </span>
                                                    DO Address/POI:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DropOffAddressPOI}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        123
                                                    </span>
                                                    Pickup Zip:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {PickupZip}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        123
                                                    </span>
                                                    Dropoff Zip:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields w-100">
                                                    {DropOffZip}
                                                </label>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="emptyTripDetailsRow"></Row>
                                <Row className="border rounded py-1">
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        remove_road
                                                    </span>
                                                    Total CXL/NS:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <label className="tripDetails-label-dataFields">
                                                    {GetTotalCanclNoShow()}
                                                </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                    note_stack
                                                    </span>
                                                    Pickup Remarks:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={2} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                    placeholder="Pickup Remarks here..." disabled={isEditButtonClicked}
                                                        value={pickRemarks} onChange={(e) => {ChangePickRemarks(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label text-nowrap">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                    note_stack
                                                    </span>
                                                    Dropoff Remarks:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={2} style={{resize:"none"}} className="tripDetails-label-dataFields mt-1 float-start w-100" 
                                                        placeholder="Dropoff Remarks here..." disabled={isEditButtonClicked}
                                                            value={dropRemarks} onChange={(e) => {ChangeDropRemarks(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                        
                                    </Col>
                                    <Col xs={6} className="user-select-none">
                                        <Row>
                                            <Col xs={5}> 
                                                <label className="tripDetails-label">
                                                    <span className="material-symbols-outlined tripDetails-googlefonts-icon">
                                                        page_info
                                                    </span>
                                                    Extra Info:
                                                </label>
                                            </Col>
                                            <Col xs={7}> 
                                                <textarea rows={6} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" placeholder="Enter Extra Info here" disabled={isEditButtonClicked}
                                                    value={ExtraInfo} onChange={(e) => {ChangeExtraInfo(e.target.value)}}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                            </Container>
                    </Modal.Body>
                    <Modal.Footer style={{backgroundColor:"#4c859b"}} className="p-1">
                        
                        <Button className="tripDetails_edit_btn_color" variant="success" onClick={handleValidateTripInformation}>
                            {SAVE_BUTTON}
                        </Button>
                    
                        <Button className="tripDetails_edit_btn_color" variant="secondary" onClick={handleCloseTripDetailsDialog}>
                            {CANCEL_BUTTON}
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
            :""}
            {showActivationAlert ? 
                <Modal centered show={showActivationAlert} onHide={handleAlertModalClose} keyboard={true} animation={true} backdrop="static" >
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='activate_dialog_title_color user-select-none'>{activateAlert.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none"><b>{activateAlert.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>
            :""}

            <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
            onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} onClose={handleConfirmationModalCancel}
            btnOkText={confirmationModalObj.btnOkText} btnCanceText={confirmationModalObj.btnCanceText} ShowCancelButton="true"/>

        </>
    )
}

export default TripDetailsDialog;